import Skeleton from './Skeleton';

/** Skeleton yang meniru layout CardProduct (cover tegak, penulis, judul, harga, tombol). */
const SkeletonCardProduct = () => (
    <article className="w-full shadowCard p-3 flex flex-col gap-3" aria-busy="true">
        {/* cover */}
        <Skeleton className="aspect-[1/1.15] w-full rounded-[12px]" />

        {/* penulis + judul */}
        <div className="flex flex-col gap-2">
            <Skeleton className="h-3 w-1/3" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
        </div>

        <div className="h-px w-full bg-blue-cs-200" />

        {/* harga */}
        <Skeleton className="h-5 w-1/2" />

        {/* tombol keranjang + beli */}
        <div className="flex items-center gap-3 w-full">
            <Skeleton className="h-[51px] w-[51px] shrink-0" />
            <Skeleton className="h-[51px] flex-1" />
        </div>
    </article>
);

export default SkeletonCardProduct;
